module.exports = __webpack_public_path__ + "img/other_pic05.b73dc5c9.png";